import { Taal } from '@cak-legacy/klantondersteuning-client';

export function mapLanguageToTaal(language: string): Taal {
  switch (language.toLowerCase()) {
    case 'nl':
    case 'nl-nl':
      return Taal.Nederlands;
    case 'en':
    case 'en-us':
      return Taal.Engels;
    default:
      throw new Error(`Language ${language} is not supported`);
  }
}
